import { useFela } from 'react-fela';

import { Loadable } from '@/modules/ui';

import { useNewSecretPage } from '../../hooks/useNewSecretPage';
import { BackButton } from '../BackButton';
import { MaxSaasSecretsFirewall } from '../MaxSaasSecretsFirewall';
import { NewSecretForm } from '../NewSecretForm';
import { NewSecretFormProvider } from '../NewSecretFormProvider';
import { NewSecretHeading } from './NewSecretHeading';
import * as felaRules from './NewSecretPage.rules';

export const NewSecretPage = () => {
    const { showLoader } = useNewSecretPage();

    const { css } = useFela();

    if (showLoader) {
        return <Loadable showLoader />;
    }

    return (
        <MaxSaasSecretsFirewall>
            <main className={css(felaRules.contentContainer)}>
                <BackButton />
                <NewSecretHeading />
                <NewSecretFormProvider>
                    <NewSecretForm />
                </NewSecretFormProvider>
            </main>
        </MaxSaasSecretsFirewall>
    );
};
